<template>
  <svg
    v-bind="$attrs"
    :width="width"
    :height="height"
    viewBox="0 0 9 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.21627 3.42857H5.05952V2.14286H6.3244V1.28571H5.05952V0H4.21627V1.28571H2.95139V2.14286H4.21627V3.42857ZM2.52976 7.28571C2.06597 7.28571 1.69072 7.67143 1.69072 8.14286C1.69072 8.61429 2.06597 9 2.52976 9C2.99355 9 3.37302 8.61429 3.37302 8.14286C3.37302 7.67143 2.99355 7.28571 2.52976 7.28571ZM6.74603 7.28571C6.28224 7.28571 5.90699 7.67143 5.90699 8.14286C5.90699 8.61429 6.28224 9 6.74603 9C7.20982 9 7.58928 8.61429 7.58928 8.14286C7.58928 7.67143 7.20982 7.28571 6.74603 7.28571ZM2.99355 5.14286H6.13467C6.45089 5.14286 6.72917 4.96714 6.87252 4.70143L8.5 1.69714L7.76637 1.28571L6.13467 4.28571H3.17485L1.37872 0.428571H0V1.28571H0.843254L2.36111 4.53857L1.10466 6.85714H7.58928V6H2.52976L2.99355 5.14286Z"
      :fill="fill"
    />
  </svg>
</template>

<script lang="ts" setup>
defineProps({
  width: {
    type: [String, Number],
    default: 9,
  },
  height: {
    type: [String, Number],
    default: 9,
  },
  fill: {
    type: String,
    default: '#3C3B3B',
  },
});
</script>